import CurrencySelector, { Variant } from './CurrencySelector';

export default CurrencySelector;
export { Variant };
